import { Helmet } from "react-helmet-async";

import { canonicalUrl, webpageJsonLd } from "@/config/seo.config";
import type { SeoProps } from "@/types/seo";

export function Seo({ path, title, description, robots = "index,follow", jsonLd = [] }: SeoProps) {
  const schema = [webpageJsonLd({ path, title, description }), ...jsonLd];

  return (
    <Helmet>
      <title>{title}</title>
      <meta name="description" content={description} />
      <meta name="robots" content={robots} />
      <link rel="canonical" href={canonicalUrl(path)} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={canonicalUrl(path)} />
      <meta property="og:type" content="website" />
      <script type="application/ld+json">{JSON.stringify(schema)}</script>
    </Helmet>
  );
}
